import { useEffect, useRef, useState } from "react";
import { BUSINESS } from "@/lib/site";

export const DutchieEmbed = ({ scriptId, src, minHeight = 600, testId, label }) => {
  const hostRef = useRef(null);
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    const host = hostRef.current;
    if (!host) return undefined;
    host.innerHTML = "";
    setStatus("loading");
    const script = document.createElement("script");
    script.async = true;
    script.id = scriptId;
    script.src = src;
    script.onerror = () => setStatus("error");
    host.appendChild(script);
    const observer = new MutationObserver(() => {
      const frames = host.querySelectorAll("iframe");
      frames.forEach((f, i) => { if (i > 0) f.remove(); });
      if (frames.length) setStatus("ready");
    });
    observer.observe(host, { childList: true, subtree: true });
    const slow = setTimeout(() => setStatus((s) => (s === "loading" ? "slow" : s)), 15000);
    return () => { observer.disconnect(); clearTimeout(slow); host.innerHTML = ""; };
  }, [scriptId, src]);

  return (
    <div className="relative w-full" style={{ minHeight: status === "ready" ? undefined : minHeight }} data-testid={testId}>
      {status !== "ready" && status !== "error" && (
        <div className="absolute inset-0 flex flex-col items-center justify-center gap-4" data-testid={`${testId}-loading`} role="status">
          <span className="loader-dot" aria-hidden="true" />
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-neutral-500">
            {status === "slow" ? "Still loading the menu…" : `Loading ${label}…`}
          </p>
        </div>
      )}
      {status === "error" && (
        <div className="flex flex-col items-center justify-center gap-3 px-6 py-20 text-center" data-testid={`${testId}-error`} role="alert">
          <p className="font-display text-2xl font-bold">The live menu didn't load.</p>
          <p className="max-w-md text-sm text-neutral-600">
            Please refresh the page or check your connection. You can also call us at{" "}
            <a className="font-bold underline underline-offset-4" href={BUSINESS.phoneHref}>{BUSINESS.phone}</a>.
          </p>
        </div>
      )}
      <div ref={hostRef} className="dutchie-host w-full" />
    </div>
  );
};
